import React, { useState } from 'react';
import ProjectCard from '../../components/ProjectCard';
import { ProjectData, Project } from '../../projectsList';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import './styles.css';

const Fade = require('react-reveal/Fade');

export default function MyProjects() {
    const [page, setPage] = useState(1)
    
    function handleNextPage() {
      setPage(page + 1)
    }

    function handlePreviousPage() {
      setPage(page + -1)
    }

    let start = (page - 1) * 1;
    let end = start + 1;

    const paginatedProjects = ProjectData.slice(start, end);

    const numberOfPages = ProjectData.length / 1

    if(page > numberOfPages){
        setPage(1)
    } else if (page < 1) {
        setPage(numberOfPages)
    }
    
    console.log(ProjectData)

    return(
        <div id="my-projects" className="container">
            <legend>My projects</legend>
            <div className="projects-desktop">
                {ProjectData.map((project: Project) => (
                    <Fade bottom>
                        <ProjectCard 
                            key={project.id}
                            image={project.image}
                            name={project.name}
                            stack={project.stack}
                            technologies={project.technologies}
                            description={project.description}
                            codeLink={project.codeLink}
                            siteLink={project.siteLink}
                        />
                    </Fade>
                ))}
            </div>
            <div className="projects-mobile">
                <ArrowBackIcon className="arrow" onClick={handlePreviousPage}/>
                {paginatedProjects.map((project: Project) => (
                    <ProjectCard 
                        key={project.id}
                        image={project.image}
                        name={project.name}
                        stack={project.stack}
                        technologies={project.technologies}
                        description={project.description}
                        codeLink={project.codeLink}
                        siteLink={project.siteLink}
                    />
                ))}
                <ArrowForwardIcon className="arrow" onClick={handleNextPage}/>
            </div>
            <button className="projects-button" ><a href="https://github.com/Brian-Mello?tab=repositories" target="blank">More projects</a></button>
        </div>
    )
};